import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/_layout/category-config/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <Navigate to='/category-config/groups' />;
}
